import { CustomSelect } from '../../vendors/custom-slect'
import { transformPathName, transformSlug } from '@/js/helpers/transform-slug'
import { UTM } from '@/js/enums/utm'
import { seoUtmSource } from '@/js/constants/seo-variables'

const singleCTA = () => {
  if (document.querySelector('#content-cta-select-grade')) {
    const selectGrade = new CustomSelect('#content-cta-select-grade')
  }

  const btn = document.getElementById('submit-content-cta')

  if (btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault()

      const formGrade = document.querySelector('#content-cta-select-grade button').value
      const formGradeName = document.querySelector('#content-cta-select-grade button').textContent
      const formSelectElement = document.querySelector('#content-cta-select-grade .field-border')
      const submitButtonText = document.querySelector('#submit-content-cta').value

      if (formGrade) {
        formSelectElement.classList.remove('error')
        formSelectElement.classList.add('valid')
      } else {
        formSelectElement.classList.remove('valid')
        formSelectElement.classList.add('error')
      }

      if (formGrade) {
        writeCookie('formGrade', formGrade, 1)
        writeCookie('formGradeName', formGradeName, 1)

        function writeCookie (name, val, expiresDay) {
          const date = new Date()
          date.setDate(date.getDate() + expiresDay)
          document.cookie = name + '=' + val + '; path=/; expires=' + date.toUTCString()
        }

        const currentUrl = new URL(window.location.href)
        const currentPathName = transformPathName(currentUrl.pathname) || 'main'
        const appUrl = document.getElementById('brighterly_land_url').value
        const utmContent = transformSlug(submitButtonText)

        const url = new URL(appUrl)
        url.searchParams.set('grade', formGrade)
        url.searchParams.set(UTM.UTM_SOURCE, seoUtmSource)
        url.searchParams.set(UTM.UTM_MEDIUM, currentPathName)
        url.searchParams.set(UTM.UTM_CAMPAIGN, 'side_bar')
        url.searchParams.set(UTM.UTM_CONTENT, utmContent)

        window.location.href = url.toString()
      }
    })
  }
}
export default singleCTA
